import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, Sparkles } from 'lucide-react';
import { useChatbot } from '../context/ChatbotContext';

const ChatbotPage: React.FC = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [showComingSoon, setShowComingSoon] = useState(false);
  const { isOpen, closeChat } = useChatbot();

  useEffect(() => {
    const timer = setTimeout(() => setShowTooltip(true), 3000);
    const hideTimer = setTimeout(() => setShowTooltip(false), 8000);

    return () => {
      clearTimeout(timer);
      clearTimeout(hideTimer);
    };
  }, []);

  // Empêcher l'ouverture du chat (désactivé temporairement)
  useEffect(() => {
    if (isOpen) {
      closeChat();
    }
  }, [isOpen, closeChat]);

  const handleComingSoon = () => {
    setShowComingSoon(true);
    setShowTooltip(false);
    window.setTimeout(() => setShowComingSoon(false), 3000);
  };

  return (
    <div className="fixed bottom-6 right-6 z-[99999]">
      <AnimatePresence>
        {showTooltip && !showComingSoon && (
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            className="absolute right-full mr-4 top-1/2 -translate-y-1/2 w-64"
          >
            <div className="bg-white rounded-lg shadow-lg p-4 border border-gray-200">
              <div className="flex items-start space-x-2">
                <Sparkles className="w-5 h-5 text-indigo-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm font-semibold text-gray-900 mb-1">
                    Besoin d&apos;aide ?
                  </p>
                  <p className="text-xs text-gray-600">
                    L&apos;assistante IA Iris sera bientôt disponible.
                  </p>
                </div>
              </div>
              <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full">
                <div className="w-0 h-0 border-t-8 border-b-8 border-l-8 border-transparent border-l-white"></div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {showComingSoon && (
          <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 8 }}
            className="absolute bottom-full right-0 mb-3 whitespace-nowrap bg-white text-gray-900 text-sm font-semibold px-4 py-2 rounded-xl shadow-lg border border-amber-200"
          >
            Bientôt disponible
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        onClick={handleComingSoon}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className="relative w-16 h-16 rounded-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-lg hover:shadow-xl transition-shadow flex items-center justify-center z-[99999]"
        aria-label="Chat Iris - Bientôt disponible"
      >
        <MessageCircle className="w-7 h-7" />
        <motion.div
          className="absolute inset-0 rounded-full bg-indigo-400 pointer-events-none"
          initial={{ scale: 1, opacity: 0.5 }}
          animate={{ scale: 1.4, opacity: 0 }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeOut',
          }}
        />
      </motion.button>
    </div>
  );
};

export default ChatbotPage;
